module.exports = __webpack_public_path__ + "img/Document.07f9bb20.svg";